import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { countriesDATA, planArea, logisticsData, bankData } from '../request';
import { quillEditor } from 'vue-quill-editor'; //富文本编辑区
import quillConfig from '@/views/components/editor/quill-config.js';
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import controlItem from '../controlItem.vue';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { statistics, control, controlGroup, fileFormat, controlGroupInfo } from '../utils';
import { uploadFile } from '../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import addTableControlModel from '../addTableControlModel.vue';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
import tableDesignModel from '../tableDesignModel.vue';
import relationModel from '../relationModel.vue';
import controlAction from './controlAction.vue';
import tableControl from './tableControl.vue';
import signModel from './signModel.vue'; //签名组件
import customModel from './customModel.vue'; //自定义组件

import SignatureControl from './SignatureControl.vue'; //签名组件--------------------
import ParagraphControl from './ParagraphControl.vue'; //段落组件----------
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
import { mapState, mapMutations } from 'vuex';
export default {
  props: {
    groupItem: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: null
    },
    groupFormData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    topTitle,
    areaSelect,
    previewModal,
    controlItem,
    addTableControlModel,
    tableDesignModel,
    relationModel,
    quillEditor,
    signModel,
    tableControl,
    customModel,
    controlAction,
    SignatureControl,
    //签名组件
    ParagraphControl
  },
  data() {
    return {
      // 下拉国家数据
      currentOptions: [],
      //获取接口数据
      // selectedValues: [], //下拉选中的值
      propsTree: {
        children: 'children',
        label: 'name',
        value: 'id',
        multiple: false
      },
      selectedValue: '',
      //单选选中数据国家
      getcountData: [],
      areaList: [],
      valuedata: [],
      //存储省市数据
      provinceDATA: [],
      //获取接口数据
      // 签名控件
      signatureIMAGE: '',
      //签名默认为空
      // 段落控件
      controlCount: 0,
      // 控件序号
      quillOption: quillConfig,
      // 定义一个全局的index作为传值 附件
      // 单选 横向 竖向
      sortWay: 'TRANSVERSE',
      //默认横向展示
      columnsPerRow: 3,
      // 结束
      selectedOption: '',
      //被选中的选项值
      showInput: false,
      //默认隐藏
      inputValue: '',
      //输入框
      formeFalse1: false,
      // 附件内容
      activeIndex: null,
      Datatemplate: [],
      //上传的文件数据
      fileListData: [],
      //上传的文件数据
      DatatemplateFalse: false,
      indexQJ: null,
      //定义文件长传的index用于传值
      isModalVisible: false,
      //文件数据
      // 日期控件
      dateTimeValue: 'date',
      selectedDate: null,
      selectedDateTime: null,
      dateFormat: 'YYYY-MM-DD',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      startTimeOption: 'unlimited',
      specificTime: null,
      relativeTime: 0,
      relativeUnit: 'days',
      visiblecustom: false,
      //下拉选择自定义
      selectedcustom: false,
      //下拉选择自定义
      // formDataArray: [], //获取的数据 用于v-for循环数据列表
      MinMaxindex: 0,
      //每个点击项的索引值作为全局使用
      DataArray: [],
      titleInput: '',
      //表单区名称
      isActive: -1,
      //选中之后改变样式
      isSelected: false,
      //关联、下拉、编辑
      // 存储的表单数据
      formData: {},
      minWordCount: 0,
      maxWordCount: 500,
      rulesTrue: {
        //统一控件说明如下：
        // 名称设置：
        // 控件名称：单行文本框，限制为0-500个字符。
        // 默认情况下，将填入控件类型的名称。
        // 非必填。如果删除了控件名称，在控件位置上方会进行补位。如果控件名称过长，会根据页面宽度换行显示。
        controlName: [{
          required: false,
          message: this.$t('请输入') + this.$t('控件名称'),
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 500 个字符之间',
          trigger: 'blur'
        }],
        // 提示文字：单行文本框，限制为0-100个字符。
        // 用于给控件提供提示信息。
        promptText: [{
          message: '长度最多为 100 个字符',
          trigger: 'blur'
        }],
        // 控件说明：单行文本框，限制为0-100个字符。
        // 如果填写了控件说明，控件名称后面会显示一个说明图标。鼠标悬停在图标上时，会显示说明内容。
        controlExplain: [{
          max: 100,
          message: '长度最多为 100 个字符',
          trigger: 'blur'
        }],
        // 其他：
        // 标识：单行文本框，必填，限制为1-50个字符。
        // 添加控件后会自动生成一个随机标识，但您也可以手动修改。如果输入框被清空并失去焦点后，将恢复为随机标识。
        mark: [{
          required: true,
          message: '请输入标识',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符之间',
          trigger: 'blur'
        }],
        prefix: [{
          message: '请输入...',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 50个字符',
          trigger: 'blur'
        }],
        suffix: [{
          message: '请输入....',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 100个字符',
          trigger: 'blur'
        }],
        mark: [{
          required: true,
          message: '请输入....',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 100个字符',
          trigger: 'blur'
        }],
        phoneRules: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '手机号格式不正确',
          trigger: 'blur'
        }],
        idCardRules: [{
          required: true,
          message: '请输入身份证号'
        }, {
          pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
          message: '身份证号格式不正确'
        }],
        emailRules: [{
          required: false,
          message: '请输入邮箱',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]{1,18}@[a-zA-Z0-9]+\.com$/,
          message: '邮箱格式不正确',
          trigger: 'blur'
        }]
      },
      defaultOption: '全部',
      subDataList: [],
      // 结束--------------------------------------------------------
      //图片需要参数
      action: uploadFile,
      uploadAccept: '',
      checkAll: false,
      indeterminate: false,
      fileDialog: false,
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      statistics,
      control,
      controlGroup,
      dialogVisible: false,
      isEdit: false,
      dataForm: {
        partsType: '',
        formName: '',
        controlName: '',
        controlExplain: '',
        promptText: '',
        other: '',
        type: '',
        optionList: [],
        fileFormat: [],
        template: []
      },
      dataGroupForm: {},
      dataGroupRules: {},
      name: '',
      checked: false,
      //默认必填为否
      controlList: [],
      containerVisible: false,
      tableDesignModelVisible: false,
      relationModelVisible: false,
      relationData: [],
      relationModelIndex: 0,
      tableId: '',
      tableMark: '',
      // 关联模块相关
      isHaveRelation: false
    };
  },
  computed: {
    controlInfo() {
      return {
        1: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }]
        },
        2: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          option: [{
            required: true,
            message: this.$t('请填写控件选项，不同选项用“，”隔开'),
            trigger: 'blur'
          }]
        },
        3: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: this.$t('请选择') + this.$t('类别'),
            trigger: 'change'
          }]
        },
        4: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          dateType: [{
            required: true,
            message: this.$t('请选择') + this.$t('日期类型'),
            trigger: 'change'
          }]
        },
        5: {
          controlName: [{
            required: true,
            message: this.$t('请输入') + this.$t('控件名称'),
            trigger: 'blur'
          }],
          fileFormat: [{
            type: 'array',
            required: false,
            message: this.$t('请选择') + this.$t('文件格式'),
            trigger: 'change'
          }]
        },
        6: {
          operation: [{
            required: true,
            message: this.$t('请选择') + this.$t('操作'),
            trigger: 'change'
          }]
        },
        7: {}
      };
    },
    item() {
      return this.groupItem;
    },
    groupDatas() {
      return this.groupFormData;
    },
    ...mapState('control', ['controlDatas', 'activeIdx', 'groupItemActiveIdx', 'groupSelected']),
    formDataArray: {
      get() {
        return this.controlDatas;
      },
      set(val) {
        this.$emit('formDataArray', val);
      }
    }
  },
  watch: {
    selectedValue(newValue) {
      console.log('选中的值为:', newValue);
    },
    minWordCount(newMin, oldMin) {
      if (this.maxWordCount <= newMin) {
        this.maxWordCount = newMin + 1;
      }
    },
    activeIdx(val) {
      if (val) {
        this.groupDatas.forEach((item, index) => {
          item.isCheck = false;
        });
      }
    }
  },
  created() {},
  mounted() {
    console.log('获取  id-------', this.itemid);
    // this.getcount();
    // this.$nextTick(() => {
    //   this.initCanvas();
    // });
  },
  methods: {
    ...mapMutations({
      SET_ACTIVE_IDX: 'control/SET_ACTIVE_IDX',
      SET_GROUP_ITEM_ACTIVE_IDX: 'control/SET_GROUP_ITEM_ACTIVE_IDX',
      SET_CONTROL_DATAS: 'control/SET_CONTROL_DATAS'
    }),
    // 日期事件
    timeSelectChange(item) {
      if (item.type === 'SPECIFIC_TIME' && item.dateInput) {
        item.dateInput = '';
      } else {
        item.value = '';
      }
    },
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(index) {
      // console.log(this.activeIdx,index,this.formDataArray,this.formDataArray[this.activeIdx],'------点击获取当前父级idx-----',this.item)
      // 判断父级是否选中状态
      if (this.groupSelected && this.item.groupSelected) {
        this.item.isCheck = true;
        this.item.groupSelected = true;
        // console.log(this.formDataArray, '-----子集选中-----', this.groupItemActiveIdx);
        this.SET_GROUP_ITEM_ACTIVE_IDX(index);
        this.changeFormDataArray(index, false);
      }
    },
    // 修改数据的isCheck
    changeFormDataArray(idx) {
      // console.log(idx, '----groupItem-----');
      this.groupDatas.forEach((item, index) => {
        if (idx === index) {
          item.isCheck = true;
          // item.groupSelected = true
        } else {
          item.isCheck = false;
        }
      });
      this.SET_CONTROL_DATAS(this.formDataArray);
      this.$forceUpdate();
    },
    // top点击事件显示输入框
    handleOptionClick(item1, index2) {
      this.formDataArray[index2].selectedOption = item1.name;
      this.formDataArray[index2].controlValue.forEach(item => {
        if (item !== item1) {
          item.showInput = false;
          item.emptyValue = '';
        }
      });
      item1.showInput = item1.isWrite;
      item1.emptyValue = '';
    },
    // 多选控件事件 数值控制 最大值 最小值
    handleNumberLimit1Change(index) {
      if (this.item.numberLimit1 >= this.item.numberLimit2) {
        // 如果第一个输入框的值大于等于第二个输入框的值，则将第二个输入框的最小值设置为第一个输入框的值加1
        this.item.numberLimit2 = this.item.numberLimit1 + 1;
      }
    },
    handleOptionChange(item2, index2) {
      if (item2.isWrite) {
        const index = this.formDataArray[index2].selectedOptionsDX.indexOf(item2.name);
        if (index !== -1) {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = '';
            }
          });
        } else {
          this.formDataArray[index2].controlValue.forEach(opt => {
            if (opt.name === item2.name) {
              opt.emptyValue = null;
            }
          });
        }
      }
    },
    // 多选添加事件
    addOptionDX(index, index1) {
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };
      this.item.controlValue.push(newOption);
    },
    //上移多选
    moveUpDX(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index - 1, 0, option);
    },
    //下移多选
    moveDownDX(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDX(index, index1) {
      this.groupDatas[index1].controlValue.splice(index, 1);
    },
    // 单选控件事件
    addOptionDA(index, index1) {
      console.log('单选事件点击增加--', index);
      const newOption = {
        name: '',
        isWrite: false,
        emptyValue: '',
        association: {
          type: '',
          // "or或 and且",
          association: [] // 如果为空则代表没有关联关系
        }
      };
      this.item.controlValue.push(newOption);
    },
    // 上移单选
    moveUpDA(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index - 1, 0, option);
    },
    // 下移单选
    moveDownDA(index, index1) {
      const option = this.groupDatas[index1].controlValue[index];
      this.groupDatas[index1].controlValue.splice(index, 1);
      this.groupDatas[index1].controlValue.splice(index + 1, 0, option);
    },
    deleteOptionDA(index, index1) {
      this.groupDatas[index1].controlValue.splice(index, 1);
    },
    // 单选结束
    // 下拉控件事件开始------------------------------------------------------
    // 是否多选事件
    MultipleShow(item) {
      if (item.isMultipleChoice === false) {
        this.selectedValue = ''; // 清空单选情况下的选择值
        this.propsTree.multiple = false;
        console.log('点击否', this.selectedValue);
      } else if (item.isMultipleChoice === true) {
        this.selectedValue = ''; // 清空单选情况下的选择值
        this.propsTree.multiple = true;
        console.log('点击是', this.selectedValue);
      }
    },
    //下拉国家 省市 省市区
    customClickVue(item, index) {
      // 自定义
      if (item === 'custom') {
        this.visiblecustom = true;
        this.treelist(index);
        // this.$nextTick(() => {
        //   this.visiblecustom = true; // 在下一个渲染周期中设置为true
        // });
      }
      // 职业
      if (item === 'profession') {
        this.currentOptions = [];
      }
      // 国家
      if (item === 'country') {
        this.getcount(index);
      }

      // 省
      if (item === 'provinceFirstLevel') {
        this.getprovince(index);
      }
      // 省市
      if (item === 'province') {
        this.getprovinceS(index);
      }
      // 省市区
      if (item === 'provinceArea') {
        this.getprovinceArea(index);
      }
      // 开户行
      if (item === 'bank') {
        this.getbank(index);
      }
      // 物流
      if (item === 'logistics') {
        this.getlogistics(index);
      }
    },
    // 下拉自定义事件
    handleOk(index) {
      this.visiblecustom = false;
      // this.item.type.type = '';
    },
    // 获取创建的tree数据  ---2、自定义列表数据
    treelist(data, index) {
      // 处理从子组件传递过来的树形数据
      this.item.Customvalues = data;
      console.log('子传父--2、自定义列表数据', data);
    },
    // 更新选中的值'
    handleCascaderChange(value) {
      // this.item.selectedValues = value; // 更新选中的值
      // console.log('更新选中的值', this.item.selectedValues);
    },
    // 获取国家接口数据
    async getcount(index) {
      // this.getcountData = await countriesDATA({});
      const res = await countriesDATA({});
      this.item.Customvalues = res;
    },
    // 获取省数据
    async getprovince() {
      const res = await planArea({
        level: 1,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取省市数据
    async getprovinceS(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 2,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取省市区数据
    async getprovinceArea(index) {
      // this.provinceDATA = await planArea({level: 2});
      const res = await planArea({
        level: 3,
        type: 'noAll'
      });
      this.item.Customvalues = res;
    },
    // 获取开户行
    async getbank(index) {
      const res = await bankData({
        level: 1
      });
      this.item.Customvalues = res;
    },
    // 获取物流
    async getlogistics(index) {
      const res = await logisticsData({
        level: 1
      });
      this.item.Customvalues = res;
    },
    minMaxNav(index) {
      this.MinMaxindex = index;
      console.log('获取每个节点的index', index);
    },
    // 单行文本 小数点位数 没有输入内容 并且失去焦点 将数据设置为默认状态
    xsdDefault1(index) {
      if (!this.item.decimalPlaces) {
        this.item.decimalPlaces = 2;
      }
    },
    // 单行文本 没有输入内容 并且失去焦点 将数据设置为默认状态
    zsxzDefault1(index) {
      if (!this.item.textMinLength) {
        this.item.textMinLength = 0;
      }
    },
    zsxzDefault2(index) {
      if (!this.item.textMaxLength) {
        this.item.textMaxLength = 200;
      }
    },
    //数值限制 最小 默认值
    szxzNumberMIN(index) {
      if (!this.item.numberMinValue) {
        this.item.numberMinValue = 0;
      }
    },
    //数值限制 最大  默认值
    szxzNumberMAX(index) {
      if (!this.item.numberMaxValue) {
        this.item.numberMaxValue = 40000000;
      }
    },
    updateNumberMaxValue() {
      const decimalPlaces = this.formData.decimalPlaces;
      const minValue = this.formData.numberMinValue;
      this.formData.numberMaxValue = Math.pow(10, decimalPlaces) * 40000000 + minValue;
    },
    //
    // 多行文本业务逻辑
    // 多行文本--字数限制
    multilineMIN(index) {
      if (!this.item.minWordCount) {
        this.item.minWordCount = 0;
      }
    },
    // 多行文本--字数限制
    multilineMAX(index) {
      if (!this.item.maxWordCount) {
        this.item.maxWordCount = 500;
      }
    },
    // 编辑按钮--打开内容输入内容
    formeClick(index, type) {
      // console.log('编辑点击事件', item, index);
      if (type === 'table') {
        //表格控件的编辑特殊处理
        this.tableId = this.item.containerTemplateId;
        if (this.tableId !== -1) {
          let obj = {
            type: 'table',
            tableType: 'increment',
            tableUsage: 'control',
            id: this.tableId,
            mark: this.item.mark
          };
          sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
          this.tableDesignModelVisible = true;
        } else {
          this.tableMark = this.item.mark;
          this.containerVisible = true;
        }
      } else {
        this.item.editing = !this.item.editing;
      }
    },
    // 关闭事件
    formClose(index) {
      this.item.editing = false;
    },
    // 关联控件
    relationClick(index) {
      this.relationModelVisible = true;
      this.relationModelIndex = index;
      let relationArr = [];
      this.formDataArray.forEach((item, index1) => {
        if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(item.partsType) != -1 && index1 < index) {
          relationArr.push(item);
        }
      });
      this.relationData = relationArr;
    },
    editSubData(subData) {
      // 编辑逻辑
    },
    // 模板预览打开
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    // 单选
    onChangeFormat(index) {
      console.log('点击事件--获取文件类型数据', this.item.fileFormat);
      this.toChangeUploadAccept(this.item.fileFormat);
    },
    // 文件上传逻辑
    clickPlusTWO(index) {
      this.indexQJ = index;
      console.log('获取点击的index', index);
      // 文件的类型的数据
      if (this.item.fileFormat.length == 0) {
        this.$message.error(this.$t('请选择文件格式'));
        return;
      }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      // 定义一个全局的index
      const index = this.indexQJ;
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // 文件类型
      if (!this.item.fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return;
      }
      // 文件列表
      this.item.fileListData = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          this.item.templateUrl += item.url + ',';
        }
        return item;
      });
      // 移除最后一个逗号
      this.item.templateUrl = this.item.templateUrl.slice(0, -1);
      this.showActionButtons = true;
    },
    // 附件上传新建
    beforeUpload(file) {
      const index = this.indexQJ;
      console.log('获取点击的index -------beforeUpload', index);
      // if (this.item.fileFormat.length == 0) {
      if (this.item.fileFormat.length < 0) {
        this.$message.error('请选择1111文件格式');
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      const isValidType = this.item.fileFormat.includes(extension);
      if (!isValidType) {
        this.$message.error(this.$t('无效的文件格式'));
      }
      const isValidSize = file.size / (this.item.fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.item.fileSize.size;
      if (!isValidSize) {
        this.$message.error(this.$t('文件大小超过限制'));
      }
      return isValidType && isValidSize;
    },
    // 结束
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    changeUpload({
      file,
      fileList
    }) {
      console.log('获取验证规则', file, fileList);
      const isThanMax = file.size / 1024 / 1024 < 50;
      const isVideoThanMax = file.size / 1024 / 1024 < 300;
      if (isVideo(file.name)) {
        if (!isVideoThanMax) {
          this.$message.error(this.$t('文件最大不超300M'));
          return;
        }
      } else {
        if (!isThanMax) {
          this.$message.error(this.$t('文件最大不超50M'));
          return;
        }
      }
      // this.item.fileFormat
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      const res = this.DataArray.indexOf(fileType);
      if (res > -1) {
        this.Datatemplate = fileList.map(item => {
          if (item.response && item.response.code == 200 && item.status == 'done') {
            if (process.env.NODE_ENV === 'production') {
              item.url = cryptoDecrypt(item.response.data).fileTempUrl;
            } else {
              item.url = item.response.data.fileTempUrl;
            }
          }
          return item;
        });
        console.log('-------', this.Datatemplate);
      } else {
        this.$message.error(this.$t('文件格式错误'));
      }
      setTimeout(() => {
        const classActions = document.getElementsByClassName('ant-upload-list-item-actions');
        if (classActions.length > 0) {
          for (const key in classActions) {
            if (classActions[key].firstChild) {
              classActions[key].firstChild.style.opacity = '1';
              classActions[key].firstChild.style.pointerEvents = 'initial';
            }
          }
        }
      }, 50);
    },
    openDesign() {
      this.tableDesignModelVisible = true;
    },
    saveTableData(res) {
      this.item['containerTemplateId'] = res.id;
      this.item['containerTemplateInfo'] = JSON.stringify(res);
    }
  }
};